import { DocRow } from '../Libraries/libraries.component';
import { signal } from '@angular/core';

/**
 * Define DocRow Tree Node
 * */
export class DocRowNode {
  public expanded = false;

  constructor(
    public name: string,
    public level = 1,
    public expandable = false,
    public doc: DocRow | null = null,
    public parentKey?: string,
    public children: DocRowNode[] = [],
    public isLoading = signal(false)
  ) {}
}
